import { requestService } from '../helpers/request.service';

export const searchService = {
    getConsultations,
    getPreauthorizations,
    getMMPreauthorizations,
    getMMRecords,
    getContestations,
    getMMContestations

}

/* Cautare */

function getConsultations(params) {
    return requestService.get({
        methodName: '/Search/GetConsultations',
        queryString: params
    });
}

function getPreauthorizations(params) {
    return requestService.get({
        methodName: '/Search/GetPreauthorizations',
        queryString: params
    });
}

function getMMPreauthorizations(params) {
    return requestService.get({
        methodName: '/Search/GetMMPreauthorizations',
        queryString: params
    });
}

function getMMRecords(params) {
    return requestService.get({
        methodName: '/Search/GetMMRecords',
        queryString: params
    });
}

/* Contestatiile */
function getContestations(params) {
    return requestService.get({
        methodName: '/Search/GetContestations',
        queryString: params
    });
}

function getMMContestations(params) {
    return requestService.get({
        methodName: '/Search/GetMMContestations',
        queryString: params
    });
}